//Remove padding on cart page from lens advisor widget(since it's not visible):
if (document.querySelector(".template-cart")) {
  const isLensAdvisor = document.querySelector(".lensadvisor-widget");
  if (isLensAdvisor) {
    isLensAdvisor.closest(".section").classList.add("no-padding");
  }
}

if (document.querySelector("[data-custom-accordion]")) {
  document.querySelectorAll("[data-custom-accordion]").forEach((item) => {
    item
      .querySelector("[data-custom-accordion-trigger]")
      .addEventListener("click", (e) => {
        const isAccordionOpen =
          item.getAttribute("data-custom-accordion") == "opened" ? true : false;
        const hidingComponent = item.querySelector(
          "[data-custom-accordion-content]"
        );
        if (isAccordionOpen) {
          //Close:
          hidingComponent.style.maxHeight = 0 + "px";
          item.setAttribute("data-custom-accordion", "closed");
        } else {
          let realHeight;
          if (hidingComponent.querySelector("scroll-carousel")) {
            realHeight =
              hidingComponent.querySelector("scroll-carousel").scrollHeight +
              40;
          } else {
            realHeight = hidingComponent.scrollHeight;
          }
          hidingComponent.style.maxHeight = realHeight + "px";
          item.setAttribute("data-custom-accordion", "opened");
        }
      });
  });
}

if (document.querySelector(".template-product")) {
  document.addEventListener("DOMContentLoaded", function () {
    const button = document.querySelector(
      '.template-product .shopify-product-form .buy-buttons [type="submit"]'
    );
    const stickyClass = "stickyATC";

    function checkButtonVisibility() {
      const rect = button.parentElement.getBoundingClientRect();

      if (rect.top < 0) {
        button.classList.add(stickyClass);
      } else {
        button.classList.remove(stickyClass);
      }
    }

    // Add an event listener for the scroll event
    window.addEventListener("scroll", checkButtonVisibility);

    // Initial check in case the button is not visible on page load
    checkButtonVisibility();
  });

  const allAccordions = document.querySelectorAll(
    "safe-sticky.product-info .productInfoAccordion"
  );
  if (allAccordions.length) {
    allAccordions[0].classList.add("firstAccordion");
    allAccordions[allAccordions.length - 1].classList.add("lastAccordion");
  }
}

const displayProxy = () => {
  if (
    document.querySelector(".template-product #fbx_product_icon_embed").style
      .display != "none"
  ) {
    const newTryButton = document.createElement("button");
    newTryButton.classList.add("proxyTryOn");
    newTryButton.innerHTML =
      '<span class="textContent">Try-on</span><span class="loader"></span>';
    newTryButton.addEventListener("click", (e) => {
      document
        .querySelector(".template-product  #fbx_product_icon_embed img")
        .click();
      newTryButton.classList.add("isLoading");
      setTimeout(() => {
        newTryButton.classList.remove("isLoading");
      }, 2000);
    });
    document
      .querySelector(".template-product  .product-gallery__media-list-wrapper")
      .appendChild(newTryButton);
    document
      .querySelector(".template-product #fbx_product_icon_embed")
      .classList.add("customBtnAdded");
  }
};
if (document.querySelector(".template-product #fbx_product_icon_embed")) {
  if (
    document.querySelector(".template-product #fbx_product_icon_embed").style
      .display != "none"
  ) {
    displayProxy();
  } else {
    let timeRun = 0;
    const awaitWidgetReady = setInterval(() => {
      timeRun += 2500;
      if (
        document.querySelector(".template-product #fbx_product_icon_embed").style
          .display != "none"
      ) {
          displayProxy();
          clearInterval(awaitWidgetReady)
        }else if(timeRun >= 15000)
          clearInterval(awaitWidgetReady)
    }, 2500);
  }
}
